module.exports = __webpack_public_path__ + "static/media/pago6.f64d00ab.svg";